import React from 'react';
import FeatureCard from './FeatureCard';

const Features: React.FC = () => {
  const features = [
    {
      title: 'Fast Pre-Approval',
      description: 'Get pre-approved for your car loan in just 5 minutes with our streamlined online application process.',
      icon: '⚡'
    },
    {
      title: '$500 CAD Cash Back',
      description: 'Purchase a car from us and receive $500 CAD cash back! Limited time offer.',
      icon: '💰'
    },
    {
      title: 'No Hidden Fees',
      description: 'Transparent pricing with no surprise fees. What you see is what you pay - guaranteed.',
      icon: '🔍'
    },
    {
      title: 'Flexible Terms',
      description: 'Choose from flexible payment terms that fit your budget and lifestyle perfectly.',
      icon: '📅'
    },
    {
      title: 'Drive Today',
      description: 'Get behind the wheel of your new car today with our same-day approval and delivery options.',
      icon: '🚗'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Us for Your Next Car?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We make car financing simple, transparent, and fast.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {features.map((feature, index) => {
            // Make cashback card extra prominent
            const isCashback = feature.title.includes('Cash Back');
            return (
              <FeatureCard
                key={index}
                title={feature.title}
                description={feature.description}
                icon={feature.icon}
                className={isCashback ? "bg-gradient-to-br from-yellow-400 to-yellow-500 border-4 border-yellow-300 shadow-2xl transform hover:scale-105 transition-transform" : ""}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
